export const q = {
    myChantiers: () => ({ sql: `select c.*, p.name_fr as project_name from chantiers c left join projects p on p.id = c.project_id where c.deleted_at is null order by c.code`, params: [] }),
    chantier: (id) => ({ sql: `select * from chantiers where id = ?`, params: [id] }),
    lots: (chantierId) => ({ sql: `select * from lots where chantier_id = ? and deleted_at is null order by sort_order, name`, params: [chantierId] }),
    /** Articles with lot name and latest progress (% from the newest event by device time). */
    articlesWithProgress: (chantierId) => ({
        sql: `select a.*, l.name as lot_name, l.sort_order,
            (select p.pct from progress_events p where p.article_id = a.id order by p.device_ts desc, p.server_ts desc limit 1) as pct,
            (select p.qty from progress_events p where p.article_id = a.id order by p.device_ts desc, p.server_ts desc limit 1) as qty_done
          from articles a join lots l on l.id = a.lot_id
          where a.chantier_id = ? and a.deleted_at is null
          order by l.sort_order, a.number`,
        params: [chantierId],
    }),
    progressHistory: (articleId) => ({ sql: `select * from progress_events where article_id = ? order by device_ts desc limit 50`, params: [articleId] }),
    /** Simple average roll-up for the field UI (weighted % is an admin/server concern, PRD M04-06). */
    chantierProgress: (chantierId) => ({
        sql: `with latest as (select a.id, (select p.pct from progress_events p where p.article_id = a.id order by p.device_ts desc limit 1) as pct from articles a where a.chantier_id = ? and a.deleted_at is null)
          select count(*) as articles, sum(case when pct >= 100 then 1 else 0 end) as done, avg(pct) as pct_simple from latest`,
        params: [chantierId],
    }),
    openNeeds: (chantierId) => ({
        sql: `select n.*, pr.designation_fr as product_name, pr.designation_ar as product_name_ar
          from needs n left join products pr on pr.id = n.product_id
          where n.chantier_id = ? and n.deleted_at is null and n.state not in ('closed','rejected')
          order by n.blocking desc, case n.priority when 'blocking' then 0 when 'urgent' then 1 else 2 end, n.created_at desc`,
        params: [chantierId],
    }),
    needHistory: (needId) => ({ sql: `select * from need_events where need_id = ? order by device_ts`, params: [needId] }),
    products: (search = "") => ({
        sql: `select * from products where active = 1 and (? = '' or designation_fr like ? or designation_ar like ? or synonyms like ? or code like ?) order by designation_fr limit 100`,
        params: [search, `%${search}%`, `%${search}%`, `%${search}%`, `%${search}%`],
    }),
    team: (chantierId) => ({
        sql: `select a.id as assignment_id, a.role, a.person_id, p.name_fr, p.name_ar, p.function
          from assignments a join persons p on p.id = a.person_id
          where a.chantier_id = ? and a.deleted_at is null and (a.end_date is null or a.end_date >= date('now'))
          order by p.name_fr`,
        params: [chantierId],
    }),
    /** Latest attendance record per person for a day (append-only → newest wins). */
    attendance: (chantierId, date) => ({
        sql: `select e.* from attendance_events e
          where e.chantier_id = ? and e.date = ?
            and e.device_ts = (select max(x.device_ts) from attendance_events x where x.person_id = e.person_id and x.date = e.date and x.chantier_id = e.chantier_id)`,
        params: [chantierId, date],
    }),
    unreadNotifications: () => ({ sql: `select count(*) as n from notifications where read_at is null`, params: [] }),
    notifications: () => ({ sql: `select * from notifications order by created_at desc limit 100`, params: [] }),
    attachmentsOf: (ownerTable, ownerId) => ({ sql: `select * from attachments where owner_table = ? and owner_id = ? and deleted_at is null order by created_at`, params: [ownerTable, ownerId] }),
    rejectedOps: () => ({ sql: `select * from sync_operations where status = 'rejected' order by applied_ts desc limit 50`, params: [] }),
};
//# sourceMappingURL=queries.js.map